/**
 * FoneFunShop one-at-a-time product media lightbox.
 * Images + hosted/external video; leaves 3D models on Dawn modal.
 * Touch: pinch-to-zoom / pan / double-tap zoom on image slides (FFS_PINCH_ZOOM v1).
 */
(function () {
  'use strict';

  if (window.__FFS_PRODUCT_LIGHTBOX_LOADED__) return;
  window.__FFS_PRODUCT_LIGHTBOX_LOADED__ = true;

  const SELECTOR_MODAL = 'product-modal.product-media-modal, product-modal.media-modal';
  const OPENER_TOGGLE =
    '.product__modal-opener--image .product__media-toggle, ' +
    '.product__modal-opener--video .product__media-toggle, ' +
    '.product__modal-opener--external_video .product__media-toggle';

  function largestFromSrcset(srcset) {
    if (!srcset) return null;
    let best = null;
    let bestW = -1;
    srcset.split(',').forEach(function (part) {
      const bits = part.trim().split(/\s+/);
      if (!bits[0]) return;
      const w = bits[1] && bits[1].endsWith('w') ? parseInt(bits[1], 10) : 0;
      if (w >= bestW) {
        bestW = w;
        best = bits[0];
      }
    });
    return best;
  }

  function absUrl(url) {
    if (!url) return '';
    try {
      return new URL(url, window.location.href).href;
    } catch (e) {
      return url;
    }
  }

  /** Prefer click-to-play; strip autoplay / force mute on embeds. */
  function quietEmbedUrl(src) {
    if (!src) return src;
    try {
      const u = new URL(src, window.location.href);
      const host = u.hostname || '';
      if (host.indexOf('youtube') !== -1 || host.indexOf('youtu.be') !== -1) {
        u.searchParams.set('autoplay', '0');
        u.searchParams.set('mute', '1');
        u.searchParams.set('playsinline', '1');
        u.searchParams.set('enablejsapi', '1');
      } else if (host.indexOf('vimeo') !== -1) {
        u.searchParams.set('autoplay', '0');
        u.searchParams.set('muted', '1');
      }
      return u.href;
    } catch (e) {
      return src;
    }
  }

  function slideFromDeferredMedia(dm) {
    const id = String(dm.getAttribute('data-media-id') || '');
    if (!id) return null;
    const posterImg = dm.querySelector('.deferred-media__poster img, img');
    const poster =
      (posterImg &&
        (largestFromSrcset(posterImg.getAttribute('srcset')) ||
          posterImg.currentSrc ||
          posterImg.getAttribute('src'))) ||
      '';
    const alt = (posterImg && posterImg.getAttribute('alt')) || '';
    const tpl = dm.querySelector('template');
    if (!tpl) return null;
    const root = tpl.content;
    const video = root.querySelector('video');
    if (video) {
      const sources = Array.from(video.querySelectorAll('source'))
        .map(function (s) {
          return { src: s.getAttribute('src'), type: s.getAttribute('type') || '' };
        })
        .filter(function (s) {
          return !!s.src;
        });
      if (!sources.length && video.getAttribute('src')) {
        sources.push({ src: video.getAttribute('src'), type: '' });
      }
      if (!sources.length) return null;
      return {
        type: 'video',
        id: id,
        sources: sources,
        poster: poster || video.getAttribute('poster') || '',
        alt: alt || video.getAttribute('aria-label') || '',
      };
    }
    const iframe = root.querySelector('iframe');
    if (iframe) {
      const src = iframe.getAttribute('src') || iframe.getAttribute('data-src') || '';
      if (!src) return null;
      return {
        type: 'external_video',
        id: id,
        src: src,
        className: iframe.getAttribute('class') || '',
        title: iframe.getAttribute('title') || alt || 'Product video',
        poster: poster,
        alt: alt,
      };
    }
    return null;
  }

  function collectSlides(rootModal) {
    const scope = rootModal || document.querySelector(SELECTOR_MODAL);
    if (!scope) return [];
    const content = scope.querySelector('.product-media-modal__content') || scope;
    const slides = [];
    const seen = new Set();
    const nodes = content.querySelectorAll('img[data-media-id], deferred-media[data-media-id]');
    nodes.forEach(function (node) {
      if (node.closest('product-model, .product-media-modal__model')) return;
      // Poster imgs live inside deferred-media — handled via the deferred-media node
      if (node.tagName === 'IMG' && node.closest('deferred-media')) return;

      const id = String(node.getAttribute('data-media-id') || '');
      if (!id || seen.has(id)) return;

      if (node.tagName === 'IMG') {
        const src =
          largestFromSrcset(node.getAttribute('srcset')) ||
          node.currentSrc ||
          node.getAttribute('src');
        if (!src) return;
        seen.add(id);
        slides.push({
          type: 'image',
          id: id,
          src: src,
          alt: node.getAttribute('alt') || '',
        });
        return;
      }

      if (node.tagName === 'DEFERRED-MEDIA') {
        const slide = slideFromDeferredMedia(node);
        if (!slide) return;
        seen.add(id);
        slides.push(slide);
      }
    });
    return slides;
  }

  function ensureDom() {
    let el = document.getElementById('FFSProductLightbox');
    if (el && el.querySelector('.ffs-lightbox__controls') && el.querySelector('.ffs-lightbox__media')) {
      return el;
    }
    if (el) el.remove();
    el = document.createElement('div');
    el.id = 'FFSProductLightbox';
    el.className = 'ffs-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Product media');
    el.innerHTML =
      '<div class="ffs-lightbox__stage">' +
      '<button type="button" class="ffs-lightbox__btn ffs-lightbox__close" aria-label="Close">&times;</button>' +
      '<div class="ffs-lightbox__controls">' +
      '<button type="button" class="ffs-lightbox__btn ffs-lightbox__nav ffs-lightbox__prev" aria-label="Previous">&#10094;</button>' +
      '<div class="ffs-lightbox__counter" aria-live="polite"></div>' +
      '<button type="button" class="ffs-lightbox__btn ffs-lightbox__nav ffs-lightbox__next" aria-label="Next">&#10095;</button>' +
      '</div>' +
      '<img class="ffs-lightbox__img" alt="" />' +
      '<div class="ffs-lightbox__media" hidden></div>' +
      '</div>';
    document.body.appendChild(el);
    return el;
  }

  const Lightbox = {
    el: null,
    img: null,
    mediaHost: null,
    controls: null,
    counter: null,
    prevBtn: null,
    nextBtn: null,
    closeBtn: null,
    slides: [],
    index: 0,
    lastFocus: null,
    _boundKey: null,
    _pointerId: null,
    _startX: 0,
    _startY: 0,
    _lastX: 0,
    _dragging: false,
    _swiped: false,
    _ignoreClick: false,

    init: function () {
      if (this._inited) return;
      this._inited = true;
      this.el = ensureDom();
      this.img = this.el.querySelector('.ffs-lightbox__img');
      this.mediaHost = this.el.querySelector('.ffs-lightbox__media');
      this.controls = this.el.querySelector('.ffs-lightbox__controls');
      this.counter = this.el.querySelector('.ffs-lightbox__counter');
      this.prevBtn = this.el.querySelector('.ffs-lightbox__prev');
      this.nextBtn = this.el.querySelector('.ffs-lightbox__next');
      this.closeBtn = this.el.querySelector('.ffs-lightbox__close');
      const stop = function (e) {
        e.stopPropagation();
      };
      // Controls must never bubble to backdrop close
      this.closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        this.close();
      }.bind(this));
      this.prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        this.prev();
      }.bind(this));
      this.nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        this.next();
      }.bind(this));
      if (this.controls) {
        this.controls.addEventListener('click', stop);
        this.controls.addEventListener('pointerdown', stop);
      }
      if (this.counter) {
        this.counter.addEventListener('click', stop);
        this.counter.addEventListener('pointerdown', stop);
      }
      // Media clicks must not bubble to backdrop close (swipe still uses stage)
      if (this.mediaHost) {
        this.mediaHost.addEventListener('click', stop);
      }
      this.el.addEventListener(
        'click',
        function (e) {
          if (this._ignoreClick) {
            this._ignoreClick = false;
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          // Only true backdrop — never controls / stage content / arrow gutters
          if (!this.shouldCloseOnBackdropClick(e)) return;
          this.close();
        }.bind(this)
      );
      this._boundKey = this.onKey.bind(this);
      this.installSwipe();
      this.installZoom();
      this.installIntercept();
    },

    installSwipe: function () {
      const stage = this.el.querySelector('.ffs-lightbox__stage');
      if (!stage || stage.dataset.ffsSwipe === '1') return;
      stage.dataset.ffsSwipe = '1';
      stage.style.touchAction = 'pan-y';
      const onDown = this.onPointerDown.bind(this);
      const onMove = this.onPointerMove.bind(this);
      const onUp = this.onPointerUp.bind(this);
      stage.addEventListener('pointerdown', onDown, { passive: true });
      stage.addEventListener('pointermove', onMove, { passive: false });
      stage.addEventListener('pointerup', onUp);
      stage.addEventListener('pointercancel', onUp);
      stage.addEventListener('lostpointercapture', onUp);
    },

    onPointerDown: function (e) {
      if (!this.el || !this.el.classList.contains('is-open')) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      // Don't swipe from controls or interactive video/iframe chrome
      if (
        e.target.closest(
          '.ffs-lightbox__btn, .ffs-lightbox__controls, .ffs-lightbox__media, .ffs-lightbox__video, video, iframe'
        )
      ) {
        return;
      }
      if (this._dragging && this._pointerId !== e.pointerId) {
        // Second finger down: this is a pinch, not a swipe
        this._zoomGesture = true;
        return;
      }
      this._pointerId = e.pointerId;
      this._startX = e.clientX;
      this._startY = e.clientY;
      this._lastX = e.clientX;
      this._dragging = true;
      this._swiped = false;
      try {
        e.currentTarget.setPointerCapture(e.pointerId);
      } catch (err) {}
    },

    onPointerMove: function (e) {
      if (!this._dragging || e.pointerId !== this._pointerId) return;
      this._lastX = e.clientX;
      const dx = e.clientX - this._startX;
      const dy = e.clientY - this._startY;
      if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) {
        if (e.cancelable) e.preventDefault();
      }
    },

    onPointerUp: function (e) {
      if (!this._dragging || (e.pointerId != null && e.pointerId !== this._pointerId)) return;
      const dx = this._lastX - this._startX;
      const dy = (e.clientY != null ? e.clientY : this._startY) - this._startY;
      this._dragging = false;
      this._pointerId = null;
      // Pinch / pan / zoomed state: never change slide (swipe-to-navigate only at 1x)
      if (this._zoomBlocksSwipe()) return;
      const THRESH = 40;
      const absX = Math.abs(dx);
      const absY = Math.abs(dy);
      if (absX >= THRESH && absX > absY) {
        this._swiped = true;
        this._ignoreClick = true;
        if (dx < 0) this.next();
        else this.prev();
        // Suppress the synthetic click that often follows pointerup after a swipe
        clearTimeout(this._ignoreClickTimer);
        this._ignoreClickTimer = setTimeout(
          function () {
            this._ignoreClick = false;
          }.bind(this),
          400
        );
      }
    },


    /* ---------------- Pinch-to-zoom (touch, image slides only) ---------------- */
    _zs: 1,
    _ztx: 0,
    _zty: 0,
    _zoomGesture: false,
    _zmode: null,
    _lastTap: null,

    _zoomBlocksSwipe: function () {
      return this._zoomGesture || this._zs > 1.001;
    },

    _isImageSlide: function () {
      const slide = this.slides[this.index];
      return !!(slide && slide.type === 'image' && this.img && !this.img.hidden);
    },

    /** Unscaled layout box of the image (center + size), independent of current transform. */
    _zoomBase: function () {
      const r = this.img.getBoundingClientRect();
      const s = this._zs || 1;
      const w = r.width / s;
      const h = r.height / s;
      return {
        cx: r.left + r.width / 2 - this._ztx,
        cy: r.top + r.height / 2 - this._zty,
        w: w,
        h: h,
      };
    },

    _applyZoom: function (animate) {
      if (!this.img) return;
      const img = this.img;
      if (animate) img.classList.add('ffs-lightbox__img--animate');
      else img.classList.remove('ffs-lightbox__img--animate');
      if (this._zs <= 1.001) {
        this._zs = 1;
        this._ztx = 0;
        this._zty = 0;
        img.style.transform = '';
        img.classList.remove('is-zoomed');
        if (this.el) this.el.classList.remove('ffs-lightbox--zoomed');
      } else {
        img.style.transform =
          'translate3d(' + this._ztx.toFixed(2) + 'px,' + this._zty.toFixed(2) + 'px,0) scale(' + this._zs.toFixed(4) + ')';
        img.classList.add('is-zoomed');
        if (this.el) this.el.classList.add('ffs-lightbox--zoomed');
      }
    },

    /** Keep scaled image covering its own box so it can never be dragged out of view. */
    _clampZoom: function (base) {
      const maxX = Math.max(0, (base.w * (this._zs - 1)) / 2);
      const maxY = Math.max(0, (base.h * (this._zs - 1)) / 2);
      this._ztx = Math.min(maxX, Math.max(-maxX, this._ztx));
      this._zty = Math.min(maxY, Math.max(-maxY, this._zty));
    },

    /** Set scale s1 keeping screen point (mx,my) fixed over the same image pixel. */
    _zoomTo: function (s1, mx, my, animate) {
      const base = this._zoomBase();
      const s0 = this._zs;
      s1 = Math.min(this.ZOOM_MAX, Math.max(1, s1));
      this._ztx = mx - base.cx - (s1 / s0) * (mx - base.cx - this._ztx);
      this._zty = my - base.cy - (s1 / s0) * (my - base.cy - this._zty);
      this._zs = s1;
      this._clampZoom(base);
      this._applyZoom(animate);
    },

    resetZoom: function () {
      this._zs = 1;
      this._ztx = 0;
      this._zty = 0;
      this._zmode = null;
      this._zoomGesture = false;
      this._lastTap = null;
      this._applyZoom(false);
    },

    ZOOM_MAX: 4,
    ZOOM_DOUBLE_TAP: 2.5,

    installZoom: function () {
      const stage = this.el.querySelector('.ffs-lightbox__stage');
      if (!stage || stage.dataset.ffsZoom === '1') return;
      stage.dataset.ffsZoom = '1';
      stage.addEventListener('touchstart', this.onZoomTouchStart.bind(this), { passive: false });
      stage.addEventListener('touchmove', this.onZoomTouchMove.bind(this), { passive: false });
      stage.addEventListener('touchend', this.onZoomTouchEnd.bind(this), { passive: false });
      stage.addEventListener('touchcancel', this.onZoomTouchEnd.bind(this), { passive: false });
    },

    _touchIgnored: function (e) {
      return !!(
        e.target &&
        e.target.closest &&
        e.target.closest('.ffs-lightbox__btn, .ffs-lightbox__controls, .ffs-lightbox__media, video, iframe')
      );
    },

    _startPinch: function (t1, t2) {
      this._zmode = 'pinch';
      this._zoomGesture = true;
      this._p0 = {
        dist: Math.max(1, Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY)),
        mx: (t1.clientX + t2.clientX) / 2,
        my: (t1.clientY + t2.clientY) / 2,
        s: this._zs,
        tx: this._ztx,
        ty: this._zty,
        base: this._zoomBase(),
      };
    },

    _startPan: function (t) {
      this._zmode = 'pan';
      this._zoomGesture = true;
      this._pan0 = { x: t.clientX, y: t.clientY, tx: this._ztx, ty: this._zty, base: this._zoomBase() };
    },

    onZoomTouchStart: function (e) {
      if (!this.el || !this.el.classList.contains('is-open') || !this._isImageSlide()) return;
      if (this._touchIgnored(e)) return;
      const ts = e.touches;
      if (ts.length === 1) {
        this._zoomGesture = this._zs > 1.001;
        this._tap0 = { x: ts[0].clientX, y: ts[0].clientY, t: Date.now(), moved: false };
        if (this._zs > 1.001) {
          this._startPan(ts[0]);
        } else {
          this._zmode = null;
        }
      } else if (ts.length >= 2) {
        this._tap0 = null;
        this._lastTap = null;
        this._startPinch(ts[0], ts[1]);
        if (e.cancelable) e.preventDefault();
      }
    },

    onZoomTouchMove: function (e) {
      if (!this._zmode || !this._isImageSlide()) {
        if (this._tap0 && e.touches[0]) {
          const d = Math.hypot(e.touches[0].clientX - this._tap0.x, e.touches[0].clientY - this._tap0.y);
          if (d > 10) this._tap0.moved = true;
        }
        return;
      }
      const ts = e.touches;
      if (this._tap0 && ts[0]) {
        const d = Math.hypot(ts[0].clientX - this._tap0.x, ts[0].clientY - this._tap0.y);
        if (d > 10) this._tap0.moved = true;
      }
      if (this._zmode === 'pinch' && ts.length >= 2) {
        const p = this._p0;
        const t1 = ts[0];
        const t2 = ts[1];
        const dist = Math.max(1, Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY));
        const mx = (t1.clientX + t2.clientX) / 2;
        const my = (t1.clientY + t2.clientY) / 2;
        let s1 = p.s * (dist / p.dist);
        // slight rubber-band beyond limits while fingers are down
        if (s1 < 1) s1 = 1 - (1 - s1) * 0.35;
        if (s1 > this.ZOOM_MAX) s1 = this.ZOOM_MAX + (s1 - this.ZOOM_MAX) * 0.2;
        s1 = Math.max(0.7, s1);
        const b = p.base;
        // Keep the image pixel under the start midpoint under the current midpoint
        this._ztx = mx - b.cx - (s1 / p.s) * (p.mx - b.cx - p.tx);
        this._zty = my - b.cy - (s1 / p.s) * (p.my - b.cy - p.ty);
        this._zs = s1;
        if (s1 >= 1) this._clampZoom(b);
        this._applyRaw();
      } else if (this._zmode === 'pan' && ts.length === 1 && this._zs > 1.001) {
        const q = this._pan0;
        this._ztx = q.tx + (ts[0].clientX - q.x);
        this._zty = q.ty + (ts[0].clientY - q.y);
        this._clampZoom(q.base);
        this._applyZoom(false);
      }
      if (e.cancelable) e.preventDefault();
    },

    /** Like _applyZoom but allows transient scale < 1 during pinch rubber-band. */
    _applyRaw: function () {
      const img = this.img;
      img.classList.remove('ffs-lightbox__img--animate');
      img.style.transform =
        'translate3d(' + this._ztx.toFixed(2) + 'px,' + this._zty.toFixed(2) + 'px,0) scale(' + this._zs.toFixed(4) + ')';
      const zoomed = this._zs > 1.001;
      img.classList.toggle('is-zoomed', zoomed);
      if (this.el) this.el.classList.toggle('ffs-lightbox--zoomed', zoomed);
    },

    _settleZoom: function () {
      // Snap back inside [1, max] after pinch release
      if (this._zs < 1.02) {
        this._zs = 1;
        this._ztx = 0;
        this._zty = 0;
        this._applyZoom(true);
        return;
      }
      if (this._zs > this.ZOOM_MAX) {
        const base = this._zoomBase();
        const cx = base.cx + this._ztx;
        const cy = base.cy + this._zty;
        this._zoomTo(this.ZOOM_MAX, cx, cy, true);
        return;
      }
      this._clampZoom(this._zoomBase());
      this._applyZoom(true);
    },

    onZoomTouchEnd: function (e) {
      if (!this.el || !this.el.classList.contains('is-open') || !this._isImageSlide()) return;
      const ts = e.touches;
      if (this._zmode === 'pinch') {
        if (ts.length >= 2) {
          this._startPinch(ts[0], ts[1]);
          return;
        }
        this._settleZoom();
        if (ts.length === 1 && this._zs > 1.001) this._startPan(ts[0]);
        else this._zmode = null;
        this._lastTap = null;
        this._tap0 = null;
        if (e.cancelable) e.preventDefault();
        return;
      }
      if (this._zmode === 'pan' && ts.length === 0) this._zmode = null;

      // Double-tap detection (single quick tap, twice, close together)
      const tap = this._tap0;
      this._tap0 = null;
      if (ts.length !== 0 || !tap || tap.moved || Date.now() - tap.t > 300) {
        this._lastTap = null;
        return;
      }
      const ct = e.changedTouches && e.changedTouches[0];
      const x = ct ? ct.clientX : tap.x;
      const y = ct ? ct.clientY : tap.y;
      const now = Date.now();
      const last = this._lastTap;
      if (last && now - last.t < 320 && Math.hypot(x - last.x, y - last.y) < 40) {
        this._lastTap = null;
        if (e.cancelable) e.preventDefault(); // no synthetic click / native dbl-tap zoom
        if (this._zs > 1.001) {
          this._zs = 1;
          this._ztx = 0;
          this._zty = 0;
          this._applyZoom(true);
          this._zoomGesture = false;
        } else {
          const r = this.img.getBoundingClientRect();
          // Only zoom when tapping on the picture itself
          if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) {
            this._zoomGesture = true;
            this._zoomTo(this.ZOOM_DOUBLE_TAP, x, y, true);
          }
        }
        return;
      }
      this._lastTap = { x: x, y: y, t: now };
    },

    installIntercept: function () {
      if (this._interceptInstalled) return;
      this._interceptInstalled = true;
      document.addEventListener(
        'click',
        function (event) {
          // 1) Modal openers for image / video / external_video
          const btn = event.target.closest(OPENER_TOGGLE);
          if (btn) {
            if (btn.classList.contains('product__media-zoom-none')) return;
            const opener = btn.closest(
              '.product__modal-opener--image, .product__modal-opener--video, .product__modal-opener--external_video'
            );
            if (!opener) return;
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            const mediaId = btn.getAttribute('data-media-id');
            const modalSel = opener.getAttribute('data-modal');
            const modal = modalSel
              ? document.querySelector(modalSel)
              : document.querySelector(SELECTOR_MODAL);
            this.openFromMediaId(mediaId, modal);
            return;
          }

          // 2) In-gallery deferred-media poster (main video play) → lightbox, not in-place Dawn player
          const poster = event.target.closest(
            '.product-media-container deferred-media .deferred-media__poster'
          );
          if (!poster) return;
          const dm = poster.closest('deferred-media');
          if (!dm || dm.closest('product-modal, product-model, .product-media-modal__model')) return;
          // Models stay on Dawn
          if (dm.tagName === 'PRODUCT-MODEL' || dm.closest('product-model')) return;
          const mediaId = dm.getAttribute('data-media-id');
          if (!mediaId) return;
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          const container = dm.closest('.product-media-container');
          const opener =
            (container &&
              container.querySelector(
                '.product__modal-opener--video, .product__modal-opener--external_video, .product__modal-opener'
              )) ||
            null;
          const modalSel = opener && opener.getAttribute('data-modal');
          const modal = modalSel
            ? document.querySelector(modalSel)
            : document.querySelector(SELECTOR_MODAL);
          this.openFromMediaId(mediaId, modal);
        }.bind(this),
        true
      );
    },

    openFromMediaId: function (mediaId, modal) {
      this.slides = collectSlides(modal);
      if (!this.slides.length) return false;
      let idx = this.slides.findIndex(function (s) {
        return String(s.id) === String(mediaId);
      });
      if (idx < 0) idx = 0;
      this.open(idx);
      return true;
    },

    open: function (index) {
      if (!this.el) this.init();
      this.index = index;
      this.lastFocus = document.activeElement;
      this.render();
      this.el.setAttribute('open', '');
      this.el.classList.add('is-open');
      document.body.classList.add('ffs-lightbox-open', 'overflow-hidden');
      document.addEventListener('keydown', this._boundKey);
      this.closeBtn.focus();
    },

    /** Close only on true dimmed backdrop — not image, media, controls, or arrow gutters. */
    shouldCloseOnBackdropClick: function (e) {
      const t = e.target;
      if (!t || !this.el) return false;

      // Explicit interactive / content chrome
      if (
        t.closest &&
        t.closest(
          '.ffs-lightbox__btn, .ffs-lightbox__controls, .ffs-lightbox__counter, ' +
            '.ffs-lightbox__img, .ffs-lightbox__media, .ffs-lightbox__video, ' +
            '.ffs-lightbox__embed, .ffs-lightbox__iframe, video, iframe'
        )
      ) {
        return false;
      }

      // Must be the overlay root or the stage (stage fills the dialog)
      const onBackdrop =
        t === this.el ||
        (t.classList && t.classList.contains('ffs-lightbox__stage'));
      if (!onBackdrop) return false;

      const x = e.clientX;
      const y = e.clientY;
      if (typeof x !== 'number' || typeof y !== 'number') return false;

      // Image / media geometry (img may have pointer-events:none → stage receives click)
      const contentEls = [];
      if (this.img && !this.img.hidden && this.img.style.display !== 'none') {
        contentEls.push(this.img);
      }
      if (this.mediaHost && !this.mediaHost.hidden) {
        contentEls.push(this.mediaHost);
      }
      for (let i = 0; i < contentEls.length; i++) {
        const r = contentEls[i].getBoundingClientRect();
        if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) {
          return false;
        }
      }

      // Desktop: left/right gutters hold the side arrows — never close there
      const vw = window.innerWidth || document.documentElement.clientWidth || 0;
      if (vw >= 750) {
        const gutter = 88; // ~ arrow + generous padding
        if (x < gutter || x > vw - gutter) return false;
      }

      // Mobile: top control bar band — never close there
      if (vw < 750) {
        const topBand = 88;
        if (y < topBand) return false;
      }

      return true;
    },

    close: function () {
      if (!this.el) return;
      this.pauseActiveMedia(true);
      this.resetZoom();
      this.el.removeAttribute('open');
      this.el.classList.remove('is-open');
      document.body.classList.remove('ffs-lightbox-open', 'overflow-hidden');
      document.removeEventListener('keydown', this._boundKey);
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        try {
          this.lastFocus.focus();
        } catch (e) {}
      }
    },

    pauseActiveMedia: function (clear) {
      if (!this.mediaHost) return;
      const video = this.mediaHost.querySelector('video');
      if (video) {
        try {
          video.pause();
        } catch (e) {}
      }
      const iframe = this.mediaHost.querySelector('iframe');
      if (iframe) {
        try {
          // Unload to stop YouTube/Vimeo audio
          iframe.src = 'about:blank';
        } catch (e) {}
      }
      if (clear) {
        this.mediaHost.innerHTML = '';
        this.mediaHost.hidden = true;
      }
    },

    render: function () {
      const slide = this.slides[this.index];
      if (!slide) return;

      this.pauseActiveMedia(true);
      this.resetZoom();

      const multi = this.slides.length > 1;
      if (this.controls) this.controls.hidden = !multi;
      this.prevBtn.hidden = !multi;
      this.nextBtn.hidden = !multi;
      this.counter.hidden = !multi;
      if (multi) {
        this.counter.textContent = this.index + 1 + ' / ' + this.slides.length;
      }

      if (slide.type === 'image') {
        this.img.hidden = false;
        this.img.removeAttribute('hidden');
        this.img.style.display = '';
        this.img.src = slide.src;
        this.img.alt = slide.alt || '';
        this._setStageTouchAction('none');
        this.mediaHost.hidden = true;
        this.mediaHost.innerHTML = '';
        return;
      }

      // Video / external video
      this.img.removeAttribute('src');
      this.img.alt = '';
      this.img.hidden = true;
      this.img.style.display = 'none';
      this._setStageTouchAction('pan-y');
      this.mediaHost.hidden = false;
      this.mediaHost.innerHTML = '';

      if (slide.type === 'video') {
        const video = document.createElement('video');
        video.className = 'ffs-lightbox__video';
        video.setAttribute('controls', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('preload', 'metadata');
        video.setAttribute('controlslist', 'nodownload');
        // Muted by default — user unmutes via controls (no surprise sound)
        video.muted = true;
        if (slide.poster) video.setAttribute('poster', absUrl(slide.poster));
        if (slide.alt) video.setAttribute('aria-label', slide.alt);
        slide.sources.forEach(function (s) {
          const source = document.createElement('source');
          source.src = absUrl(s.src);
          if (s.type) source.type = s.type;
          video.appendChild(source);
        });
        this.mediaHost.appendChild(video);
        // Sensible UX: click-to-play (controls visible); no autoplay
        return;
      }

      if (slide.type === 'external_video') {
        const wrap = document.createElement('div');
        wrap.className = 'ffs-lightbox__embed';
        const iframe = document.createElement('iframe');
        iframe.className = 'ffs-lightbox__iframe' + (slide.className ? ' ' + slide.className : '');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('loading', 'lazy');
        iframe.title = slide.title || 'Product video';
        iframe.src = quietEmbedUrl(absUrl(slide.src));
        wrap.appendChild(iframe);
        this.mediaHost.appendChild(wrap);
      }
    },

    _setStageTouchAction: function (v) {
      const stage = this.el && this.el.querySelector('.ffs-lightbox__stage');
      if (stage) stage.style.touchAction = v;
    },

    prev: function () {
      if (this.slides.length < 2) return;
      this.index = (this.index - 1 + this.slides.length) % this.slides.length;
      this.render();
    },

    next: function () {
      if (this.slides.length < 2) return;
      this.index = (this.index + 1) % this.slides.length;
      this.render();
    },

    onKey: function (e) {
      if (!this.el || !this.el.classList.contains('is-open')) return;
      switch (e.key) {
        case 'Escape':
          e.preventDefault();
          this.close();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          this.prev();
          break;
        case 'ArrowRight':
          e.preventDefault();
          this.next();
          break;
      }
    },
  };

  window.FFSProductLightbox = Lightbox;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      Lightbox.init();
    });
  } else {
    Lightbox.init();
  }
})();
